"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'topology'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, topology = _a.topology;
    var _b = constants_1.BUTTON_SIZES[compProps.counterPosition][compProps.size], width = _b.width, height = _b.height;
    return {
        uri: compData.uri,
        description: compData.description,
        size: compProps.size,
        color: compProps.color,
        counterPosition: compProps.counterPosition,
        staticMediaUrl: topology.staticMediaUrl,
        width: width + "px",
        height: height + "px",
    };
});
//# sourceMappingURL=PinterestPinIt.js.map